import { render, staticRenderFns } from "./OostkustView.vue?vue&type=template&id=403cbac5&"
import script from "./OostkustView.vue?vue&type=script&lang=js&"
export * from "./OostkustView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports